export default __webpack_public_path__ + "static/media/proceed.1f450375.svg";